export default __webpack_public_path__ + "static/media/login.e80b3281.svg";